import React, { useEffect, useState, Suspense } from 'react';
import { Dialog, DialogTitle, DialogContent, Button, DialogActions, Skeleton } from '@mui/material';
import Picker from '../../picker/Picker';
import useApi from '../../hooks/useApi';
import useSnackbar from '../../hooks/useSnackbar';
import useSuspenseFetch from '../../hooks/useSuspenseFetch';

const TopicsContent = ({ id, selected, onChange }) => {
    // The suspending hook lives INSIDE the component wrapped by <Suspense>
    const { data: topics } = useSuspenseFetch('topics');

    return (
        <Picker
            availableItems={topics}
            selectedItems={selected}
            onChangeItems={items => onChange({ id, topics: items })}
        />
    );
};

const SurveyTopicsDialog = ({ open, onClose, id }) => {
    const { handlePut, handleGet } = useApi();
    const { showSnackbar } = useSnackbar();
    const [surveyTopics, setSurveyTopics] = useState(null);
    const [isInitialising, setIsInitialising] = useState(true);

    const handleFetchSurveyTopics = async () => {
        const response = await handleGet(`surveys/${id}`);

        if (!response.ok) {
            showSnackbar('Failed to fetch Survey Topics', 'error');
            navigator('/editor', { state: { type: 'survey' } });
            return;
        }

        const { topics } = await response.json();

        setSurveyTopics(topics);
    };

    const handleUpdateTopics = async ({ id, topics = null }) => {
        const topicIds = topics?.map(e => e.id);

        const params = {
            autoSave: false,
            ...(topicIds && { topicIds })
        };

        const response = await handlePut(`surveys/${id}`, params);

        if (!response.ok) {
            showSnackbar('Failed to update Survey Topics', 'error');
        }
    };

    useEffect(() => {
        surveyTopics && setIsInitialising(false);
    }, [surveyTopics]);

    useEffect(() => {
        handleFetchSurveyTopics();
    }, []);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth={true}
            maxWidth="md"
        >
            <DialogTitle sx={{ m: 0, p: 2 }}>
                Survey Topics
            </DialogTitle>
            <DialogContent dividers>
                {isInitialising ? (
                    <Skeleton width="100%" />
                ) : (
                    // The Suspense boundary now *wraps the component that suspends*
                    <Suspense fallback={<Skeleton width="100%" />}>
                        <TopicsContent
                            id={id}
                            selected={surveyTopics}
                            onChange={handleUpdateTopics}
                        />
                    </Suspense>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SurveyTopicsDialog;
